module.exports = __webpack_public_path__ + "img/no_messages.202f4b68.svg";